import { Component } from '@angular/core';

type Exchange = 'Binance' | 'Coinbase' | 'CoinDCX';
type Token = 'BTC' | 'ETH' | 'XRP';

@Component({
  selector: 'app-total-investment',
  templateUrl: './total-investment.component.html',
  styleUrls: ['./total-investment.component.scss']
})
export class TotalInvestmentComponent {
   exchanges: Exchange[] = ['Binance', 'Coinbase', 'CoinDCX'];
  tokens: Token[] = ['BTC', 'ETH', 'XRP'];

  selectedToken: Token = 'BTC';

  data: Record<Exchange, Record<Token, string>> = {
    Binance: { BTC: '1000', ETH: '2000', XRP: '1500' },
    Coinbase: { BTC: '1100', ETH: '1900', XRP: '1600' },
    CoinDCX: { BTC: '1050', ETH: '1950', XRP: '1550' }
  };

  getInvestment(exchange: Exchange, token: Token): string {
    return this.data[exchange][token] || '-';
  }

}
